import React from 'react';
import EntityLeaderboardBlock from './EntityLeaderboardBlock.jsx';
import KeywordLeaderboardBlock from './KeywordLeaderboardBlock.jsx';
import { LeaderboardContainer } from './styled.js';

const TypeMap = {
  keyword: KeywordLeaderboardBlock,
  entity: EntityLeaderboardBlock,
  content: EntityLeaderboardBlock,
  social: EntityLeaderboardBlock,
};


const ReportLeaderboard = ({ type, data, reportType }) => {
  const TopComponent = TypeMap[type];

  return (
    <LeaderboardContainer>
      {data.map((item, index) => (
        <TopComponent
          data={item}
          position={index} // First array slot is user entity
          key={`leaderboard_${type}_${index}`}
          type={type}
          reportType={reportType}
        />
      )
      )}
    </LeaderboardContainer>
  );
};


export default ReportLeaderboard;
